module.exports = __webpack_public_path__ + "img/interface OneB Mapper_1 prew.00ba2efa.jpg";